import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
    palette: {
        background: {
            default: "#f4f5f8"
        }
    }
});
